import { AuthProvider } from "./auth-provider";

/**
 * No-op auth provider used when no external OIDC is configured
 * (AUTHENTICATION_PROVIDER_TYPE=none). It never leaves the user in a loading
 * state and never initializers a network auth library, so the app can render
 * public pages without Auth0/Dex.
 */
export const useNoopAuthProvider = (): AuthProvider => {
  return {
    isAuthenticated: false,
    isLoading: false,
    user: null,
    login: async () => {
      // no remote login; just log for visibility
      console.info("[noop-auth] login() — auth disabled");
    },
    logout: async () => {
      console.info("[noop-auth] logout() — auth disabled");
    },
    getAccessToken: async () => null,
    refreshAccessToken: async () => null,
    hasPermission: async () => false,
    getJson: async (url: string) => {
      throw new Error(`[noop-auth] getJson(${url}) — no auth configured`);
    },
    postJson: async (url: string) => {
      throw new Error(`[noop-auth] postJson(${url}) — no auth configured`);
    },
    postForm: async (url: string) => {
      throw new Error(`[noop-auth] postForm(${url}) — no auth configured`);
    },
    putJson: async (url: string) => {
      throw new Error(`[noop-auth] putJson(${url}) — no auth configured`);
    },
    patchJson: async (url: string) => {
      throw new Error(`[noop-auth] patchJson(${url}) — no auth configured`);
    },
    deleteJson: async (url: string) => {
      throw new Error(`[noop-auth] deleteJson(${url}) — no auth configured`);
    },
  };
};
